
export const text = `[ID: A photo of a coffin in an abandoned room. Dozens of crimson butterflies rest on its lid; their wings are reminiscent of human skulls. A lady is unconscious on the floor next to it, trenchcoat haphazardly thrown onto a table. Her buttoned shirt bears a spiral pattern. It seems to move about ever so slightly, even though it is only a picture.]



`